import moment from 'moment-mini'
import DateView from '../views/DateView'
import pickerDateMixin from './picker-date-mixin'
import { PickerType } from '../constants'

export default {
  name: 'KDatePickerDateRange',
  mixins: [pickerDateMixin],
  provide() {
    return {
      picker: this,
    }
  },
  props: {},
  data() {
    return {
      pickerType: PickerType.DateRange,
      startReferenceValue: moment(),
      endReferenceValue: moment().add(1, 'M'),
      startValue: null,
      endValue: null,
    }
  },
  computed: {
    unlinkViews() {
      return this.context.unlinkViews
    },
    joinValue() { // 用于确定选择的日期段的正确性和变化
      const { startValue, endValue } = this
      if (startValue && endValue) {
        return startValue.format('YYYYMMDD') + '-' + endValue.format('YYYYMMDD')
      }
    },
    shouldStartHeaderRenderNext() {
      return this.unlinkViews ? this.startReferenceValue.diff(this.endReferenceValue, 'month') <= -1 : false
    },
    shouldEndHeaderRenderPrev() {
      return this.unlinkViews ? this.endReferenceValue.diff(this.startReferenceValue, 'month') >= 1 : false
    },
    durationDay() {
      let durationDay = 0
      if (this.startValue && this.endValue) {
        durationDay = this.endValue.diff(this.startValue, 'day')
      } else if (this.hoveredCell && this.startValue) {
        durationDay = this.hoveredCell.value.diff(this.startValue, 'day')
      } else if (this.hoveredCell && this.endValue) {
        durationDay = this.hoveredCell.value.diff(this.endValue, 'day')
      }

      return Math.abs(durationDay)
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        if (value) {
          this.startValue = value[0]
          this.endValue = value[1]
          this.locateViews()
        }
      },
    },
    startValue(value) {
      this.$emit('startSelected', value)
    },
    endValue(value) {
      this.$emit('endSelected', value)
    },
    startReferenceValue: {
      immediate: true,
      handler(value) {
        if (!this.unlinkViews && value.diff(this.endReferenceValue, 'month') !== -1) {
          this.endReferenceValue = this.startReferenceValue.clone().add(1, 'month')
        }
      },
    },
    endReferenceValue: {
      immediate: true,
      handler(value) {
        if (!this.unlinkViews && value.diff(this.startReferenceValue, 'month') !== 1) {
          this.startReferenceValue = this.endReferenceValue.clone().subtract(1, 'month')
        }
      },
    },
    active: {
      immediate: true,
      handler(value) {
        if (value) {
          this.locateViews()
        }
      },
    },
    joinValue() {
      const { startValue, endValue } = this
      if (startValue && endValue) {
        this.$emit('pick', [startValue, endValue])
      }
    },
    hoveredCell(cell) {
      if (!cell) {
        return
      }
      const hoveredValue = cell.value

      const { startValue, endValue } = this
      if (startValue && endValue) {
        return
      }

      let picking = []

      if (startValue && hoveredValue.isBefore(startValue, 'day')) {
        this.startValue = null
        this.endValue = startValue
        picking = [hoveredValue, this.endValue]
      } else if (endValue && hoveredValue.isAfter(endValue, 'day')) {
        this.endValue = null
        this.startValue = endValue
        picking = [this.startValue, hoveredValue]
      }

      this.$emit('picking', picking)
    },
  },
  created() {
    this.$on('click-prev', (referenceValueKey) => {
      if (this.unlinkViews && referenceValueKey === 'endReferenceValue') {
        if (this.shouldEndHeaderRenderPrev) {
          this.endReferenceValue = this.endReferenceValue.clone().subtract(1, 'month')
        }
      } else {
        this[referenceValueKey] = this[referenceValueKey].clone().subtract(1, 'month')
      }
    })

    this.$on('click-next', (referenceValueKey) => {
      if (this.unlinkViews && referenceValueKey === 'startReferenceValue') {
        if (this.shouldStartHeaderRenderNext) {
          this.startReferenceValue = this.startReferenceValue.clone().add(1, 'month')
        }
      } else {
        this[referenceValueKey] = this[referenceValueKey].clone().add(1, 'month')
      }
    })
  },
  methods: {
    locateViews() {
      const { value, unlinkViews } = this
      this.startReferenceValue = (value && value[0]) || this.defaultReferenceValue || moment()
      if (unlinkViews) {
        if (value[1] && value[1].isSame(this.startReferenceValue, 'month')) {
          this.endReferenceValue = this.startReferenceValue.clone().add(1, 'M')
        } else {
          this.endReferenceValue = value[1] || this.startReferenceValue.clone().add(1, 'M')
        }
      }
    },
    handleCellClick(cell) {
      const { startValue, endValue } = this
      const selectValue = cell.value
      if (startValue && endValue) {
        this.endValue = null
        this.startValue = selectValue
      } else if (!startValue) {
        this.startValue = selectValue
      } else {
        this.endValue = selectValue
      }
    },
  },
  render() {
    const css = {
      'km-date-picker__pane-wrapper': true,
    }

    const data = {
      class: css,
    }

    const startHeader = this.renderHeader(this.startReferenceValue, {
      referenceValueKey: 'startReferenceValue',
      renderNext: this.shouldStartHeaderRenderNext,
    })
    const endHeader = this.renderHeader(this.endReferenceValue, {
      referenceValueKey: 'endReferenceValue',
      renderPrev: this.shouldEndHeaderRenderPrev,
    })

    return (
      <div {...data}>
        {this.renderShortcuts()}
        <div class="km-date-picker__pane">
          {startHeader}
          <DateView
            referenceValue={this.startReferenceValue}
          />
        </div>
        <div class="km-date-picker__pane-separator">
          {
            this.durationDay
              ? (
                <span>共{this.durationDay}天</span>
              ) : null
          }
        </div>
        <div class="km-date-picker__pane">
          {endHeader}
          <DateView
            referenceValue={this.endReferenceValue}
          />
        </div>
      </div>
    )
  },
}
